module.exports = __webpack_public_path__ + "img/tag_banner.dada7c99.png";